import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import dataModel from '../../models/DataModel';
import ToggleButton from '../Buttons/ToggleButton';
import './FeatureToggle.scss';

export default class FeatureToggle extends React.Component {
  
  constructor(props) {
    FeatureToggle.propTypes = {
      company: PropTypes.object.isRequired,
      description: PropTypes.string,
      featureName: PropTypes.string.isRequired, //property name in company.features,
      readOnly: PropTypes.bool.isRequired,
      title: PropTypes.string.isRequired,
    };
    super(props);
    const { company, featureName } = props;
    this.state = {
      featureEnabled: company.features && company.features[featureName] ? company.features[featureName].enabled : false,
    };
    this.openContactUrl = this.openContactUrl.bind(this);
    this.toggleFeature = this.toggleFeature.bind(this);
  }

  openContactUrl(contactUrl) {
    if (this.props.isMobile) {
      window.open(contactUrl, '_system');
    }
    else {
      window.location = contactUrl;
    }
  }

  toggleFeature(selected) {
    const { readOnly, company, featureName } = this.props;
    if (!readOnly) {
      this.setState({ featureEnabled: selected }, () => {
        const { featureEnabled } = this.state;
        const clonedCompany = _.cloneDeep(company);
        if (!clonedCompany.features) {
          clonedCompany.features = {};
        }
        if (!clonedCompany.features[featureName]) {
          clonedCompany.features[featureName] = {};
        }
        clonedCompany.features[featureName].enabled = featureEnabled;
        dataModel.companiesDAO.updateCompany(clonedCompany);
      });
    }
  }

  render() {
    const { featureEnabled } = this.state;
    const { readOnly, description, title } = this.props;

    return (
      <div className="feature-toggle">
        <div className="feature-toggle__caption">{title}</div>
        <div className="feature-toggle__contents">
          <div className="feature-toggle__toggle">
            <div className="toggle-caption">{featureEnabled ? 'ADD-ON ACTIVE' : 'NOT CONFIGURED'}</div>
            <div className="toggle-button">
              <ToggleButton handleClick={this.toggleFeature}
                selected={featureEnabled}
                readOnly={readOnly}/>
            </div>
          </div>
          {!featureEnabled &&
          <div className="feature-toggle__explanation">
            <p>{description}</p>
            <p className="learn-more">To learn more contact</p>
            <p className="email-link" onClick={() => this.openContactUrl('mailto:support@activeoversight.io')} >support@activeoversight.io</p>
          </div>}
          {featureEnabled && this.props.children}
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/FeatureToggle/index.js